export const LOGIN_PATH = "/auth/login"
export const SIGNUP_PATH = "/auth/register"
export const SCHOOL_PATH_HOME = "/school"
